module.exports = __webpack_public_path__ + "media/7.8017a333.mp3";